import { Usuario, UsuarioForm, UsuarioUpsert } from '@models/.';
// import { transformArrayAssociatedStoreForm } from '..';

export function transformToData(user: Usuario | null, stateId?: string): Usuario | null {
  if (!user) return null;
  
  return {
    ...user,
    fullname: `${user.nombre} ${user.apellido}`.trim(),
    active: user.estadoId === stateId,
  };
}

export function transformArrayToData(users: Usuario[], stateId?: string): Usuario[] {
  return (users ?? []).map((user) => transformToData(user, stateId)).filter((a) => !!a) ?? [];
}

export function transformToForm(user: Usuario): UsuarioForm {
  const {
    id,
    nombre,
    apellido,
    fullname,
    compania,
    titulo,
    telefono,
    correo,
    estadoId,
    // tiendasAsociadas,
    resellerId,
    cargoId,
  } = user;
  
  return {
    id: id,
    name: nombre,
    lastName: apellido,
    fullname,
    company: compania,
    title: titulo,
    phone: telefono,
    email: correo,
    stateId: estadoId,
    resellerId,
    roleId: cargoId,
    // associatedStoreIds: transformArrayAssociatedStoreForm(tiendasAsociadas).map((store) => store.id),
  };
}

export function transformToUpsert(userForm: UsuarioForm): UsuarioUpsert | undefined {
  if (!userForm) return;
  
  const {
    id,
    name,
    lastName,
    company,
    title,
    phone,
    email,
    password,
    stateId,
    // associatedStoreIds,
    resellerId,
    roleId,
    changePassword
  } = userForm
  
  return {
    nombre: name,
    apellido: lastName,
    compania: company,
    titulo: title,
    telefono: phone,
    correo: email,
    contrasena: (!id || changePassword) && !!password ? password : undefined,
    estadoId: stateId,
    resellerId,
    cargoId: roleId,
    // tiendasAsociadas: associatedStoreIds ?? [],
  };
}